import React, { useState, useEffect, useRef } from "react";
import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
  Space,
  Form,
} from "antd";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import MainLayout from "../../../../../components/layouts/MainLayout";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../../../components/layouts/TopContent";
import { onSelectItemAction, rightAction } from "../../../../../redux/actions";
import DownloadTableButtons from "../../../../../components/DownloadTableButtons";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { handleFlgStatus } from "../../../../../components/facilities/AccountFacility";

//global distructures
const { Text, Link, Title } = Typography;

const columns = [
  {
    title: labelConfig.customerId,
    dataIndex: "clientId",
  },
  {
    title: "Account Number",
    dataIndex: "accountNo",
  },
  {
    title: "Product Name",
    dataIndex: "productName",
  },
  {
    title: "Account Name",
    dataIndex: "clientName",
  },
  {
    title: "Original Loan",
    dataIndex: "originalLoan",
  },
  {
    title: " Loan Balance",
    dataIndex: "loanBalance",
  },
  // {
  //     title: 'Amount Paid',
  //     dataIndex: 'amountPaid'
  // },
  {
    title: "Loan Status",
    dataIndex: "status",
  },
];

const UnApprovedLoans = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;

  const { session } = userData;
  const [loanAccountList, setLoanAccountList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();

  //DECLARED METHODS

  useEffect(() => {
    {
      BOM.HasPermission("READ_LOAN") && getLoanAccListAction();
    }
    {
      BOM.HasPermission("CREATE_LOAN") && rightAction(cnt.RIGHT_ADD_BTN);
    }
  }, []);

  const getLoanAccListAction = () => {
    const params = {
      orderBy: "id",
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.LoanAccounts, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res?.pageItems;
        let tempArray = [];
        // console.log(tempArray)

        objList
          ?.filter(
            (item) => item?.status?.value === "Submitted and pending approval"
          )
          .forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              clientId: element?.clientId ? element?.clientId : "-",
              clientName: element?.clientName ? element?.clientName : "-",
              accountNo: element?.accountNo ? element?.accountNo : "-",
              productName: element?.loanProductName
                ? element?.loanProductName
                : "-",
              originalLoan: element?.approvedPrincipal
                ? element?.approvedPrincipal
                : "-",
              loanBalance: element?.maxOutstandingLoanBalance
                ? element?.maxOutstandingLoanBalance
                : 0,
              // amountPaid: element?.principal ? element?.principal : "-",
              status: handleFlgStatus(
                element?.status?.value,
                {},
                true,
                element
              ),
              loanType: element?.loanType ? element?.loanType?.value : "-",
              otherKeys: {
                statusValue: element?.status?.value, // The status value will be used on the detail screen
                accountNo: element?.accountNo,
              },
            });
          });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setLoanAccountList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
        orderBy: "id",
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.LoanAccounts, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res?.pageItems;
          let tempArray = [];

          objList
            ?.filter(
              (item) => item?.status?.value === "Submitted and pending approval"
            )
            .forEach((element) => {
              tempArray.push({
                key: element?.id,
                id: element?.id,
                clientId: element?.clientId ? element?.clientId : "-",
                clientName: element?.clientName ? element?.clientName : "-",
                accountNo: element?.accountNo ? element?.accountNo : "-",
                productName: element?.loanProductName
                  ? element?.loanProductName
                  : "-",
                originalLoan: element?.approvedPrincipal
                  ? element?.approvedPrincipal
                  : "-",
                loanBalance: element?.maxOutstandingLoanBalance
                  ? element?.maxOutstandingLoanBalance
                  : 0,
                // amountPaid: element?.principal ? element?.principal : "-",
                status: handleFlgStatus(
                  element?.status?.value,
                  {},
                  true,
                  element
                ),
                loanType: element?.loanType ? element?.loanType?.value : "-",
                otherKeys: {
                  statusValue: element?.status?.value, // The status value will be used on the detail screen
                  accountNo: element?.accountNo,
                },
              });
            });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [BOM.HasPermission("READ_LOAN") && cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setLoanAccountList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.accountNo?.includes(searchKey) ||
        item?.productName?.toLowerCase()?.includes(searchKey) ||
        item?.clientName?.toLowerCase()?.includes(searchKey) ||
        item?.otherKeys?.statusValue.toLowerCase()?.includes(searchKey)
    );
    setLoanAccountList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-loan-account", {
        state: {
          clientName: selectedRow.clientName,
          clientId: selectedRow.clientId,
          id: selectedRow.id,
          ...selectedRow.otherKeys,
          variant: "view",
        },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-acc0103", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSearch = (formValue) => {
    setIsLoading(true);

    const params = {
      exactMatch: false,
      query: formValue.searchKey,
      resource: "savings,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // console.log(res);
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.entityId,
            id: element?.entityId,
            accountNo: element?.entityAccountNo
              ? element?.entityAccountNo
              : "-",
            clientName: element?.parentName ? element?.parentName : "-",
            clientId: element?.parentId ? element?.parentId : "-",
            status: handleFlgStatus(element?.entityStatus?.value, {}, true),
            branch: element?.officeName ? element?.officeName : "-",
            savingsProductName: element?.entityName ? element?.entityName : "-",
            otherKeys: {
              statusValue: element?.entityStatus?.value, // The status value will be used on the detail screen
              accountNo: element?.accountNo,
            },
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setLoanAccountList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  const onRefresh = () => {
    useForm.resetFields();
    getLoanAccListAction();
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
    >
      <TopContent
        pageTitle={labelConfig.manageLoanApproval}
        pageItems={staticConfig.manageLoanApprovalBreadcrumbItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={"Loan Account List"}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div>

            {/* <DownloadTableButtons
              downloadData={loanAccountList}
              columns={columns}
              fileName={"Loan Approval List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={loanAccountList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(UnApprovedLoans);
